export const TIMELINE_MAIN_LOADING = "TIMELINE_MAIN_LOADING";
export const TIMELINE_MAIN_SUCCESS = "TIMELINE_MAIN_SUCCESS";
export const TIMELINE_MAIN_FAILED = "TIMELINE_MAIN_FAILED";
export const TIMELINE_MAIN_CLEAR = "TIMELINE_MAIN_CLEAR";
